import { AnyAction, combineReducers, Reducer } from "redux"
import { defaultPerPage } from "../../../shared/state/sharedTypes"
import { AddFormToCaseActionTypes, IAddFormToCaseUIState } from "../../addFormToCase/state/addFormToCaseTypes"

export const totalItemsCount: Reducer<number> = (state = 0, action: AnyAction): number => {
  switch (action.type) {
    case AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
      return action.payload.totalItems || 0
    default:
      return state
  }
}

export const totalPages: Reducer<number> = (state = 0, action: AnyAction): number => {
  switch (action.type) {
    case AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
      return action.payload.totalPages || 0
    default:
      return state
  }
}

export const searchTerm: Reducer<string> = (state = "", action: AnyAction): string => {
  switch (action.type) {
    case AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
      return action.payload.searchTerm || ""
    default:
      return state
  }
}

export const resultsPerPage: Reducer<number> = (state = defaultPerPage, action: AnyAction): number => {
  switch (action.type) {
    case AddFormToCaseActionTypes.FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS:
      return action.payload.resultsPerPage || 25
    default:
      return state
  }
}

export const addFormsToCaseUIReducer: Reducer<IAddFormToCaseUIState> = combineReducers({
  totalItemsCount,
  totalPages,
  searchTerm,
  resultsPerPage,
})
